import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import { createStoreRankMetricsDownloadConfig } from '@intelligence/components/DownloadCommon/DownloadPage/configs/storeRankMetricsDownload';

const getFilename = (params: Record<string, any>) => {
  const [startDate = '', endDate = ''] = params?.dateRange || [];
  return `Store Ranks_Mobile_Top_${startDate}_${endDate}`;
};

export default (params: Record<string, any>) => {
  return {
    ...commonSetting,
    ...createStoreRankMetricsDownloadConfig(getFilename)(params),
  };
};
